// i18n area 'storage' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da storage.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/storage.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './storage'

export const enGB: DeepPartial<typeof enUS> = {
  storage: {
    pools: {
      content: {
        catalogFiles: 'Catalogue files'
      },
      releaseRequiredBody: 'Releasing the images deletes NO bytes: unregistering leaves the namespace on disk, the images simply stop being materialised and every scope reference survives as a claim — register the pool again and they are re-adopted.'
    },
    findings: {
      kind: {
        catalogFile: 'Catalogue file'
      },
      adoptFileTitle: 'Import into a catalogue',
      adoptFileHint: 'Files exist only inside catalogues: pick the destination catalogue for the found file.',
      namespaceNotice:
        "This directory was already initialised by another storage: the identity seal has been rewritten with this storage's. The contents were NOT touched — review the objects found below, import the ones you need, then dismiss this notice."
    },
    reinit: {
      action: 'Retry initialisation'
    },
    catalogs: {
      title: 'Catalogues',
      createTitle: 'Create catalogue',
      editTitle: 'Edit catalogue',
      docTitle: 'Catalogue',
      notFound: 'This catalogue does not exist (anymore?)',
      scopeHint: 'Whoever reads this scope sees (and can use) every file in the catalogue',
      systemTooltip: 'System catalogue: it hosts the platform\'s embedded objects and cannot be changed'
    },
    catalogFiles: {
      catalog: 'Catalogue',
      copyAction: 'Copy into a catalogue…',
      copyTitle: 'Copy into a catalogue',
      copyCatalog: 'Target catalogue',
      copyCatalogHint: 'Copying is how a file travels between catalogues',
      moveHint: 'Two independent dimensions: Catalogue moves the link (same id, no byte moves, the scope becomes the target catalogue\'s); Storage moves the data — every linked copy follows, refused while the file is in use. Chosen together, catalogue first, then storage.',
      moveCatalog: 'Target catalogue',
      moveCatalogHint: 'Only the link changes home: a VM mounting the file must be able to see the target catalogue',
      rehomed: 'Link moved into the chosen catalogue',
      noCatalog: 'There is no catalogue yet — create one',
      inlineCatalogName: 'Catalogue name',
      embeddedCopyHint: 'The clone materialises the embedded bytes onto a real storage: pick the target storage and catalogue — the copy is an ordinary file'
    },
    objects: {
      kind: {
        catalogFile: 'Catalogue file'
      }
    },
    inventory: {
      tabCatalogs: 'Catalogues'
    }
  }
}
